import { render, staticRenderFns } from "./SchoolReportPage.vue?vue&type=template&id=383a01d7&scoped=true"
import script from "./SchoolReportPage.vue?vue&type=script&lang=js"
export * from "./SchoolReportPage.vue?vue&type=script&lang=js"
import style0 from "./SchoolReportPage.vue?vue&type=style&index=0&id=383a01d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383a01d7",
  null
  
)

export default component.exports